import React from "react";
import { Link } from "react-router-dom";
import { GiPathDistance , GiMountainCave} from 'react-icons/gi'
import {MdPeopleOutline} from 'react-icons/md'
import {SiMinutemailer} from 'react-icons/si'
import {FaYoutubeSquare, FaTwitterSquare, FaFacebookSquare} from 'react-icons/fa'
import { useGlobalContext } from "../context";


import img1 from '../assets/images/1.webp';
import img2 from '../assets/images/2.webp';
import img3 from '../assets/images/3.webp';

import bosco1 from '../assets/images/bosco/1.webp';
import bosco2 from '../assets/images/bosco/2.webp';
import bosco3 from '../assets/images/bosco/3.webp';
import bosco4 from '../assets/images/bosco/4.webp';

import pizzo1 from '../assets/images/pizzo/1.webp';
import pizzo2 from '../assets/images/pizzo/2.webp';
import pizzo3 from '../assets/images/pizzo/3.webp';
import pizzo4 from '../assets/images/pizzo/4.webp';

import pigna from '../assets/images/aboutus/pigna.webp';
import masha from '../assets/images/aboutus/masha.webp';
import luca from '../assets/images/aboutus/luca.webp';


const links = [
    {
        url: '/percorsi',
        text: "Percorsi",
        icon: <GiPathDistance className="link-icon"/>
    },
    {
        url: '/attrazioni',
        text: "Attrazioni",
        icon: <GiMountainCave className="link-icon"/>
    },
    {
        url: '/about',
        text: "Su di noi",
        icon: <MdPeopleOutline className="link-icon"/>
    },
    {
        url: '/contattaci',
        text: "Contattaci",
        icon: <SiMinutemailer className="link-icon"/>
    },
]

const LinkComponent = ({classLink})=>{
    const {closeSidebar} = useGlobalContext();
    return (
        <ul className={classLink}>
            {
                links.map(el=>{
                    return (
                        <Link to={el.url} key={el.url} className="link-element" onClick={closeSidebar}>
                            <div style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                            {el.icon}
                            <h5 className="link-text">
                                {el.text}
                            </h5>
                            </div>
                            <hr className="hr-hover"/>
                        </Link>
                    )
                })
            }
        </ul>
    )
}

const socialLinks = [
    {
        url: "https://www.facebook.com/",
        icon: <FaFacebookSquare className="social-icon" />,
    },
    {
        url: "https://twitter.com/home?lang=it",
        icon: <FaTwitterSquare className="social-icon" />,
    },
    {
        url: "https://www.youtube.com/",
        icon: <FaYoutubeSquare className="social-icon" />,
    },
]

const SocialLinkComponent = ({classSocial})=>{
    return(
        <ul className={classSocial}>
            {
                socialLinks.map(el=>{
                    return <a href={el.url} key={el.url}>{el.icon}</a>
                })
            }
        </ul>
    )
}

const sliderImg = [
    {
        url: img1,
        text:"Passeggiate per i sentieri del Bosco Martese",
        id:"img1",
    },
    {
        url: img2,
        text:"Panorama dalle pendici del Monte Pelone",
        id:"img2",
    },
    {
        url: img3,
        text:"Versante nord della Cima Lepri",
        id:"img3",
    },
];

const sliderBosco = [
    {
        url: bosco1,
        text:"Il bosco di Ceppo é composto prevalentemente da Faggi",
        id:"bosco1",
    },
    {
        url: bosco2,
        text:"Craterellus Cornucopioides o Trombette dei Morti",
        id:"bosco2",
    },
    {
        url: bosco3,
        text:"Il bosco é cosí fitto da non far passare la luce del sole",
        id:"bosco3",
    },
    {
        url: bosco4,
        text:"Cascata della Morricana",
        id:"bosco4",
    },
]

const sliderPizzo = [
    {
        url: pizzo1,
        text:"Pendici del Pizzo di Moscio",
        id:"pizzo1",
    },
    {
        url: pizzo2,
        text:"Prati rigogliosi del periodo Primaverile.",
        id:"pizzo2",
    },
    {
        url: pizzo3,
        text:"Dalle pendici delle montagne scorrono fonti purissime.",
        id:"pizzo3",
    },
    {
        url: pizzo4,
        text:"Monte Pelone",
        id:"pizzo4",
    },
]

const about = [
    {
        name: "Andrea",
        img: pigna,
        bio: "Programmatore e Sviluppatore Freelance, studia Informatica presso l'Universitá di Trento. Appassionato di tecnologia e di montagna. Creatore di Ceppo Trekking.",
    },
    {
        name: "Masha",
        img: masha,
        bio: "Designer e guida turistica, studia Scienze del Beni Culturali presso l'Universitá degli Studi di Udine. Ama la natura e conosce Ceppo come le sue tasche.",
    },
    {
        name: "Luca",
        img: luca,
        bio: "Artista, disegnatore ed esperto di Arte Contemporanea. Frequenta l'Accademia delle Belle Arti di Urbino. Le passeggiate in montagna sono per lui indispensabili.",
    },
]

export {LinkComponent, SocialLinkComponent, sliderImg, sliderBosco, sliderPizzo, about};